import { MouseEvent, useContext, useState } from "react";
import { StyledButton, TitleText, TitleWrapper } from "../../../shared/styled/TitleBar";
import AddIcon from "../../../shared/svg/AddIcon";
import { TitleBar } from "../../../configs/materialRequest";
import { useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";
import { Menu, MenuItem } from "@mui/material";
import CreateFromProductStepper from "../Content/CreateFromProductStepper";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = [ROLE.MANAGER, ROLE.FACTORY_MANAGER_ONE, ROLE.FACTORY_MANAGER_TWO, ROLE.DEPUTY_FACTORY_MANAGER_ONE, ROLE.DEPUTY_FACTORY_MANAGER_TWO].includes(role);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [isCreateFromProductOpen, setIsCreateFromProductOpen] = useState(false);

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (path: string, state?: any) => {
        setAnchorEl(null);
        if (path) navigate(path, { state });
    };

    return (
        <>
            {isCreateFromProductOpen && (
                <CreateFromProductStepper
                    open={isCreateFromProductOpen}
                    onClose={() => setIsCreateFromProductOpen(false)}
                    isAllowToSearchProduct={true}
                />
            )}

            <TitleWrapper>
                <TitleText>{TitleBar.title}</TitleText>
                {canCreate && (
                    <>
                        <StyledButton variant="contained" onClick={handleClick}>
                            <AddIcon />
                            {TitleBar.addButtonText}
                        </StyledButton>
                        <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose("")}>
                            <MenuItem
                                onClick={() => handleClose("/material-requests/create", { useOtherMaterials: true })}>
                                Tạo phiếu lãnh vật tư
                            </MenuItem>
                            <MenuItem onClick={() => {
                                setAnchorEl(null);
                                setIsCreateFromProductOpen(true);
                            }}>
                                Tạo phiếu lãnh từ sản phẩm
                            </MenuItem>
                        </Menu>
                    </>
                )}
            </TitleWrapper>
        </>
    );
};


export default Title;
